import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import DoctorPaymentPage from './DoctorPaymentPage.js';

export default WithGASetup(DoctorPaymentPage, AuthContext);
